<template>
  <div>
    <el-dialog :visible.sync="visible" width="50%" @close="cancelBtn">
      <div slot="title" style="border-bottom:1px solid #ccc;padding-bottom:10px;">
        “
        <span style="color:red">{{title}}</span>
        ” 项目结项报告
      </div>

      <el-form
        :model="endForm"
        ref="formRef"
        label-width="120px"
        :rules="rules"
        class="demo-ruleForm"
        style="width:96%"
      >
        <el-form-item label="结项发起人" prop="apply_user_name">
          <el-input
            v-model="endForm.apply_user_name"
            size="small"
            readonly
            placehoder="请输入结项发起人姓名"
            style="width:55%"
          ></el-input>
        </el-form-item>

        <el-form-item label="结项时间" prop="node_time">
          <el-date-picker
            v-model="endForm.node_time"
            type="date"
            size="small"
            value-format="yyyy-MM-dd"
            placeholder="结项日期"
          ></el-date-picker>
        </el-form-item>

        <el-form-item label="结项附件" required>
          <el-upload
            ref="fileUploads"
            :action="uploadFileUrl"
            :before-upload="beforeUploadFile"
            :file-list="defFile"
            :on-success="(response, file, fileList) =>{
                      handlerUpload(fileList,'defFile');
                    }"
            :on-remove="(file, fileList) =>{
                      handlerUpload(fileList,'defFile');
                    }"
            :limit="1"
          >
            <el-button size="small" type="primary">点击上传</el-button>
          </el-upload>
        </el-form-item>

        <el-form-item label="结项原因" prop="reasons">
          <el-input v-model="endForm.reasons" type="textarea" :rows="4" placeholder="请输入项目结项原因"></el-input>
        </el-form-item>
        <el-form-item label="项目摘要：">
          <span class="span_box">
            本项目自
            <i>{{abstract.regdate_start}}</i>至
            <i>{{abstract.regdate_end}}</i> 的实施期间，累计受益总人数为
            <i>{{abstract.beneficiary_number}}</i>，其中筛查
            <i>{{abstract.screen_sum}}</i>人，
            筛查出的患者中有
            <i>{{abstract.apply_count}}</i>名入院复诊接受治疗，合计使用该项目款
            <i>{{abstract.approve_sum}}</i> 元，此外医保补助总额为
            <i>{{abstract.yb_sum}}</i> 元。
          </span>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="danger" size="small" icon="el-icon-close" @click="cancelBtn">关闭</el-button>
        <el-button
          type="primary"
          size="small"
          icon="el-icon-check"
          @click="submitF"
          :loading="loading"
        >提交</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import baseUrl from "@/config/index";
export default {
  props: {
    value: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: "结项信息"
    },
    size: {
      type: [String, Number],
      default: "80%"
    },
    id: {
      type: [String, Number],
      default: null
    },
    pid: {
      type: [String, Number],
      default: null
    }
  },
  data() {
    return {
      visible: false,

      uploadFileUrl: "", //上传链接

      loading: false,
      defFile: [],

      rules: {},

      endForm: {
        apply_user_name: null,
        file_id: null,
        node_time: null,
        reasons: null
      }, //结项提交数据
      abstract: {} //项目摘要信息
    };
  },
  watch: {
    visible(val) {
      this.$emit("input", val);
    },

    value: {
      handler(val) {
        this.visible = val;
      },
      immediate: true
    }
  },
  methods: {
    cancelBtn() {
      this.visible = false;
    },

    handlerUpload(fileList, name) {
      this.$set(this, name, []);
      this.$set(this, name, fileList);
    },

    //上传结项附件
    beforeUploadFile(file) {
      let bool = this.$fnc.checkUploadFile(file);
      return bool;
    },

    //获取结项信息详情
    getProjectEndInfo(pid) {
      this.$db
        .post(this.$db.config.getProjectEndInfo, { project_id: pid })
        .then(res => {
          if (res && res.code == 200) {
            this.endForm = res.data;
            this.defFile.push({
              name: res.data.file_source_name,
              url: res.data.file_path,
              id: res.data.file_id
            });
          }
        });
    },

    //获取项目摘要（结项资料）
    getAbstract(pid) {
      this.$db
        .post(this.$db.config.getProjectPublicNodeTotal, { id: pid })
        .then(res => {
          if (res && res.code == 200) {
            this.abstract = res.data;
          }
        });
    },

    //提交结项表单
    submitF() {
      if (this.defFile && this.defFile[0]) {
        let arr = [];
        for (const item of this.defFile) {
          if (item.hasOwnProperty("response")) {
            arr.push(item.response.data.id);
          } else {
            arr.push(item.id);
          }
        }
        this.endForm.file_id = arr[0];
      } else {
        return this.$message.warning("请上传结项附件！");
      }

      this.loading = true;
      this.$refs["formRef"].validate(valid => {
        if (valid) {
          let url;
          if (this.endForm.node_id > 0) {
            url = this.$db.config.com_project.end.update;
          } else {
            url = this.$db.config.com_project.end.insert;
          }
          this.$db.post(url, this.endForm).then(res => {
            this.loading = false;
            if (res && res.code == 200) {
              this.$message.success(res.msg);
              this.cancelBtn();
              this.$emit("success");
            }
          });
        } else {
          this.loading = false;
          return this.$message.warning("请填写完整信息！");
        }
      });
    },

    /**
     * 获取当前时间
     * @param  {Number} type [1:Y-m-d 2:Y-m-d H 3:Y-m-d H:i 4:Y-m-d H:i:s]
     * @return {[type]}      [description]
     */
    getCurrentTime(type = 1) {
      var date = new Date();
      var seperator1 = "-";
      var year = date.getFullYear();
      var month = date.getMonth() + 1;
      var strDate = date.getDate();
      var hour = date.getHours();
      var minute = date.getMinutes();
      var second = date.getSeconds();
      if (month >= 1 && month <= 9) {
        month = "0" + month;
      }
      if (strDate >= 0 && strDate <= 9) {
        strDate = "0" + strDate;
      }
      if (hour >= 1 && hour <= 9) {
        hour = "0" + hour;
      }
      if (minute >= 1 && minute <= 9) {
        minute = "0" + minute;
      }
      if (second >= 1 && second <= 9) {
        second = "0" + second;
      }
      let current = year + seperator1 + month + seperator1 + strDate;
      switch (type) {
        case 1:
          break;
        case 2:
          current = current + " " + hour;
          break;
        case 3:
          current = current + " " + hour + ":" + minute;
          break;
        case 4:
          current = current + " " + hour + ":" + minute + ":" + second;
          break;
      }
      return current;
    }
  },
  mounted() {
    this.uploadFileUrl = baseUrl + this.$db.config.uploadFileUrl;
    this.getAbstract(this.pid);
    this.endForm.apply_user_name = JSON.parse(
      sessionStorage.getItem("unitAuth")
    ).user_name;
    this.endForm.project_id = this.pid;
    if (this.id > 0) {
      this.getProjectEndInfo(this.pid);
    } else {
      this.endForm.node_time = this.getCurrentTime();
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Hospital/comproject/info/end.vue